import { render, staticRenderFns } from "./Shadow.vue?vue&type=template&id=8f871fde&scoped=true&"
import script from "./Shadow.vue?vue&type=script&lang=js&"
export * from "./Shadow.vue?vue&type=script&lang=js&"
import style0 from "./Shadow.vue?vue&type=style&index=0&id=8f871fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f871fde",
  null
  
)

export default component.exports